export const CASELOAD_SOURCE_RULE_BASED = 'alpha last name mapping';
export const CASELOAD_SOURCE_CLEVER = 'clever';
export const CASELOAD_SOURCE_ONE_ROSTER = 'one roster';
export const CASELOAD_SOURCE_CUSTOM_SCRIPT = 'custom script';
export const CASELOAD_SOURCE_CSV = 'csv';
export const CASELOAD_SOURCE_AUTO = 'auto';
export const CASELOAD_SOURCE_MANUAL = 'manual';

export const STUDENT_TAG_TYPE_PERSONAL = 'personal';
export const STUDENT_TAG_TYPE_OFFICIAL = 'official';

export const RESTRICTED_TAG_MESSAGE =
  'This is a restricted tag. It cannot be seen by staff who do not have access to restricted tags on any assigned students.';
